import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';


import { paramPropType } from '../../shared/customReports/propTypes';
import { OptionsPropType } from '../../shared/propTypes/common';

import ParamForm from './paramForm.component';

export default class CustomReportParams extends PureComponent {
  static propTypes = {
    updateQueryParams: PropTypes.func.isRequired,

    params: PropTypes.arrayOf(paramPropType),
    customReportsParamsOptions: PropTypes.objectOf(OptionsPropType),

    queryParams: PropTypes.objectOf(PropTypes.string),
    isLoading: PropTypes.bool,
    archivalFlag: PropTypes.bool,
    restrictBatchDefaults: PropTypes.bool,
    userRole: PropTypes.string,
    editable: PropTypes.bool,
  };

  static defaultProps = {
    restrictBatchDefaults: false,
  };

  render() {
    const {
      params,
      customReportsParamsOptions,
      updateQueryParams,
      queryParams,
      isLoading,
      archivalFlag,
      restrictBatchDefaults,
      userRole,
      editable,
    } = this.props;

    return (
      <ParamForm
        readOnly={false}
        params={params}
        queryParams={queryParams}
        customReportParamsOptions={customReportsParamsOptions}
        updateQueryParams={updateQueryParams}
        isLoading={isLoading}
        archivalFlag={archivalFlag}
        restrictBatchDefaults={restrictBatchDefaults}
        userRole={userRole}
        editable={editable}
      />
    );
  }
}
